import { useSearchParams } from "react-router-dom";
import { useTitle } from "@/lib/site";
import { PageHeader } from "@/components/site/Shared";
import { Reveal } from "@/components/motion/Reveal";
import { ContactList } from "@/components/site/ContactList";
import { OpeningHours } from "@/components/site/OpeningHours";
import { MapFrame } from "@/components/site/MapFrame";
import { EnquiryForm } from "@/components/enquiry/EnquiryForm";

export default function Contact() {
  useTitle("Contact Us | YK Motors, Peterborough");
  const [params] = useSearchParams();
  const vehicleId = params.get("vehicle") || "";

  return (
    <>
      <PageHeader
        crumbs={[{ label: "Home", to: "/" }, { label: "Contact" }]}
        eyebrow="Contact"
        title={["Get in touch."]}
        intro="Call, email or send an enquiry. Viewings are by appointment, seven days a week."
      />
      <section className="container-x grid gap-12 py-12 lg:grid-cols-12 lg:gap-16 lg:py-20">
        <Reveal className="space-y-12 lg:col-span-5">
          <ContactList prefix="contact" />
          <div>
            <h2 className="mb-4 font-display text-xl font-extrabold">Opening hours</h2>
            <OpeningHours testId="contact-opening-hours" />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <div className="rounded-lg border border-line bg-white p-6 shadow-[0_30px_60px_-45px_rgba(11,13,18,0.5)] sm:p-8 lg:p-10">
            <p className="eyebrow">Enquiry form</p>
            <h2 className="mb-2 mt-3 font-display text-3xl font-extrabold tracking-tight">Send us a message</h2>
            <p className="mb-8 text-steel">Ask about a car, a part exchange or anything else — we'll get back to you.</p>
            <EnquiryForm key={vehicleId} defaultVehicleId={vehicleId} prefix="contact-form" />
          </div>
        </Reveal>
      </section>
      <section className="container-x pb-16 lg:pb-24" aria-label="Map">
        <MapFrame className="aspect-[4/3] sm:aspect-[16/9] lg:aspect-[21/8]" testId="contact-map" />
      </section>
    </>
  );
}
